import {Trans} from '@lingui/macro';
import React, {FC} from 'react';

import {Handler, HandlerOf, PredicateOf} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {CellsConversationsDragItem} from '../../../../helpers/conversationCellHelpers';
import {WorkspaceFolderRootLabelsEnum} from '../../../../models/api/workspaceModel';
import {WorkspaceDisplaySectionTrackingTypesEnum} from '../../../../services/tracking';
import {InboxesPanelId} from '../../../../store/panels/panelStateBase';
import {WorkspaceGenericItemContainer} from '../workspaceGenericItemContainer';

/*
 * Props.
 */

interface TeammateWorkspaceStarItemProps {
  panelId: InboxesPanelId;
  starredTagId: number;
  canConversationsDrop: PredicateOf<CellsConversationsDragItem>;
  onConversationsDrop: HandlerOf<CellsConversationsDragItem>;
  /** Is the workspace in edit mode. */
  isEditingWorkspace?: boolean;
  /** Should the checkbox be selected if we're in editing mode. */
  isChecked?: boolean;
  onClick?: Handler;
  shouldHideMoreMenu: boolean;
  canBeHidden: boolean;
}

/*
 * Component.
 */

export const TeammateWorkspaceStarItem: FC<TeammateWorkspaceStarItemProps> = (props) => (
  <WorkspaceGenericItemContainer
    canBeHidden={props.canBeHidden}
    shouldHideMoreMenu={props.shouldHideMoreMenu}
    trackingSection={WorkspaceDisplaySectionTrackingTypesEnum.STARRED}
    shouldAlphabetizeWorkspace={false}
    workspaceDragItem={undefined}
    panelId={props.panelId}
    iconName="starSmall"
    selectedIconName="starFilledSmall"
    to={props.isEditingWorkspace ? undefined : `/inboxes/teammates/views/${props.starredTagId}`}
    canConversationsDrop={props.canConversationsDrop}
    onConversationsDrop={props.onConversationsDrop}
    label={WorkspaceFolderRootLabelsEnum.STARRED}
    isEditingWorkspace={props.isEditingWorkspace}
    isChecked={props.isChecked}
    onClick={props.onClick}
  >
    <Trans id="workspace-starred">Starred</Trans>
  </WorkspaceGenericItemContainer>
);
